import React, { Component } from "react";
import { Layout, Page, Card, List, TextStyle, Banner } from "@shopify/polaris";

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const primaryAction = {
      content: "Go Pro",
      onAction: () => {
        this.changePage("/pro");
      },
    };
    const secondaryActions = [
      {
        content: "Home",
        onAction: () => {
          this.changePage("/");
        },
      },
      {
        content: "FAQ",
        onAction: () => {
          this.changePage("/faq");
        },
      },
      {
        content: "Privacy Policy",
        onAction: () => {
          this.changePage("/terms");
        },
      },
    ];

    return (
      <Page
        title="FAQ"
        primaryAction={primaryAction}
        secondaryActions={secondaryActions}
      >
        <Banner status="critical">
          <TextStyle variation="strong">
            After much consideration, we have decided to sunset the app on the
            5th of October 2024. This app will cease to function on this date.
            We are currently creating a new app that will replace this one. And
            we will notify you once it is available. We apologize for any
            inconvenience this may cause.
          </TextStyle>
        </Banner>
        <div
          style={{
            paddingTop: 20,
          }}
        ></div>
        <Layout>
          <Layout.Section>
            <Card title="Frequently Asked Questions">
              <Card.Section title="Do you provide support?">
                <p>
                  We certainly do, please feel free to get in contact with us
                  via our live chat in the bottom right of this screen or via
                  our email:
                  <br />
                  support@kiwisprout.nz
                </p>
              </Card.Section>
              <Card.Section title="Why isn't my toast appearing?">
                <p>Please check the following:</p>
                <br />
                <List>
                  <List.Item>
                    That the toast is enabled and has been saved.
                  </List.Item>
                  <List.Item>
                    That where you have selected the toast to appear matches
                    where you want the toast to appear.
                  </List.Item>
                  <List.Item>
                    If you are using a custom URL, make sure the URL you use is
                    everything after your domain name, e.g.
                    "/products/product-name/" and not
                    "https://example.com/products/product-name/"
                  </List.Item>
                </List>
              </Card.Section>
              <Card.Section title="Why aren't my changes being saved?">
                <p>
                  Make sure you are pressing the "Save" button after making your
                  changes, if that fails please try closing and reopening the
                  app, if the issue persists don't hesistate to get in touch via
                  our live chat in the bottom right of this screen or via our
                  email support@kiwisprout.nz
                </p>
              </Card.Section>
              <Card.Section title="How can I control which toast shows on a page?">
                <p>
                  Out of the toasts eligible to show for a page, the toast with
                  the highest priority will show on the page, priority can be
                  set in the advanced section when editing a toast.
                </p>
              </Card.Section>
              <Card.Section title="My toast doesn't look quite like the preview, why is that?">
                <p>
                  We try to create a consistent appearance across all forms of
                  media but it's still possible for the appearance to be
                  overridden. There could be a few reasons why the toast doesn't
                  look quite like what is shown in the preview, the most common
                  reasons are how your browser renders the toast, or the styling
                  rules of your store's theme.
                </p>
              </Card.Section>
              <Card.Section title="I accidentally deleted a toast I wanted to keep, can I recover it?">
                <p>
                  After a toast is deleted, it cannot be recovered and is
                  permanently deleted.
                </p>
              </Card.Section>
              <Card.Section title="Can I show more than one toast on a page?">
                <p>
                  To maintain our high standard of user experience only one
                  toast can be shown per page.
                </p>
              </Card.Section>
              <Card.Section title="What browsers do you support?">
                <p>
                  We support the same browsers as Shopify, which includes the
                  latest versions of:
                </p>
                <br />
                <List>
                  <List.Item>Google Chrome</List.Item>
                  <List.Item>Mozilla Firefox</List.Item>
                  <List.Item>Apple Safari</List.Item>
                  <List.Item>Microsoft Edge</List.Item>
                  <List.Item>Opera</List.Item>
                  <List.Item>Apple Safari for IOS</List.Item>
                  <List.Item>Google Chrome for Android</List.Item>
                </List>
              </Card.Section>
              <Card.Section title="Can I edit the background gradient for pro presets?">
                <p>The gradient background for pro presets cannot be edited.</p>
              </Card.Section>
              <Card.Section title="What does font weight mean?">
                <p>
                  Font weight is how thick the characters of the text will
                  appear, the selected font weight will match the closest font
                  weight available.
                </p>
              </Card.Section>
              <Card.Section title="What screen size does 'disable on mobile devices' hide on?">
                <p>767 pixels and below.</p>
              </Card.Section>
              <Card.Section title="Do I need to make any code changes to my website after installing or uninstalling?">
                <p>
                  You should not have to make any changes to the website after
                  installing or uninstalling this app, we do not make any
                  changes to your theme's.
                </p>
              </Card.Section>
              <Card.Section title="How do I show my toast only on a specific page?">
                <p>
                  If you're on the pro plan, you can select "Custom URL" as the
                  location where your toast appears, then select "Exact match"
                  as the condition and place everything after your domain for
                  the page URL into the text field. For example, if you wanted
                  your toast to appear on
                  "mystore.com/products/my-special-product" you would put
                  ""/products/my-special-product" in the text field. If you
                  wanted the toast to show regardless of the query parameters,
                  for example,
                  "mystore.com/products/my-special-product?colour=blue" then you
                  should select "Starts with" so that any url that starts with
                  "products/my-special-product" will show your toast.
                </p>
              </Card.Section>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  // Change our page, but only if our current page is done loading to prevent memory leaks
  changePage = (url, keepParams = true) => {
    this.props.history.push(url + (keepParams ? window.location.search : ""));
  };

  valueUpdater(field) {
    return (value) => this.setState({ [field]: value });
  }
}

export default FAQ;
